import cn from "classnames";
import { useTranslation } from "next-i18next";

import i from "@styles/icons.module.scss";

import { passengersInfoType } from "../../contants";

import s from "./Passengers.module.scss";

const Passengers = ({
  className,
  passengers,
  updatePassengers,
  passengersCount,
  preschoolChildWarning,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn(s.passengers, className)} {...props}>
      <div className={s.wrap}>
        <div className={s.triangle} />
      </div>
      {Object.entries(passengers).map(([type, value]) => (
        <div className={s.type} key={type}>
          <div className={s.name}>
            <div className={s.text}>
              {t(`passengers.type.${type}.title`, { count: value })}
            </div>
            <div className={s.info}>{t(`passengers.type.${type}.info`)}</div>
          </div>
          <div className={s.controls}>
            <div
              onClick={() => updatePassengers(type, value - 1)}
              className={cn(
                s.button,
                s.minus,
                (passengersCount <= 0 || value === 0) && s.disabled,
              )}
            >
              <icon className={i.minus} />
            </div>
            <div className={s.count}>{value}</div>
            <div
              className={s.button}
              onClick={() => updatePassengers(type, value + 1)}
            >
              <icon className={i.plus_v2} />
            </div>
          </div>
        </div>
      ))}
      {preschoolChildWarning && (
        <div className={s.warning}>{t("passengers.preschoolChildWarning")}</div>
      )}
    </div>
  );
};

export default Passengers;
